export default __webpack_public_path__ + "static/media/login_two.51565e71.jpg";